export default {
      id: "oc-expand-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-expand",
      toString: function () {
        return this.url;
      }
    }